'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProducts = undefined;

var _middleware = require('../../middleware');

var _paths = require('./paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

/**
 * getProducts
 * 
 * Fetches a list of products.
 * @param {String} feis_id 
 */
var getProducts = exports.getProducts = function getProducts(feis_id) {
  return function (dispatch, getState) {

    var products = (0, _paths.productsPath)(getState(), feis_id);

    // prefer the cached version
    if (products) return Promise.resolve();

    return dispatch(_defineProperty({
      feis_id: feis_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/products'
      },
      types: ['GET_PRODUCTS_START', 'GET_PRODUCTS', 'GET_PRODUCTS_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/products/getProducts.js
// module id = 154
// module chunks = 0